// Org-level default currency. Singleton doc, upserted on first read. Used by
// the Settings → General page and as the prefill currency for new leads.
// Leads can still carry their own currency (per-lead override).

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { crmApi } from "../api/client";
import { DEFAULT_CURRENCY } from "../lib/currency";

const KEY = ["crm", "settings", "currency"];

export function useOrgCurrency() {
  const q = useQuery({
    queryKey: KEY,
    queryFn: async () => (await crmApi.get("/settings/currency")).data,
    staleTime: 5 * 60_000,
  });
  return {
    ...q,
    currency: q.data?.settings?.currency || DEFAULT_CURRENCY,
  };
}

export function useUpdateOrgCurrency() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (currency) =>
      (await crmApi.patch("/settings/currency", { currency })).data,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEY });
    },
  });
}
